import React from 'react';

const MaintenancePage = () => (
  <div className="fixed inset-0 bg-gradient-to-br from-gray-900 to-black flex items-center justify-center p-6">
    <div className="max-w-md w-full text-center">
      <img
        src="/logos/logo-transparent-smll.png"
        alt=""
        className="h-16 w-auto object-contain mx-auto mb-6"
      />
      <div className="w-16 h-16 rounded-full bg-yellow-500/20 flex items-center justify-center mx-auto mb-6">
        <svg className="w-8 h-8 text-yellow-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      </div>
      <h1 className="text-2xl font-bold text-white mb-3">We'll Be Right Back</h1>
      <p className="text-gray-400 leading-relaxed">
        Loft is currently undergoing scheduled maintenance. We're working hard to improve your experience and will be back shortly. Thanks for your patience!
      </p>
    </div>
  </div>
);

export default MaintenancePage;
